import { render, staticRenderFns } from "./cjh.vue?vue&type=template&id=030652c3&scoped=true"
import script from "./cjh.vue?vue&type=script&lang=js"
export * from "./cjh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030652c3",
  null
  
)

export default component.exports